import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Autocomplete } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Axios } from "api/axios";
import BootstrapTextField from "Common/BootstrapTextField";
import CancelButton from "Common/Components/Buttons/CancelButton";
import PrimarySubmitButton from "Common/Components/Buttons/PrimarySubmitButton";
import { MecordColors } from "Constants/Color";
import { autocompleteDropdownStyles } from "Constants/Style";
import { City, Country, State } from "country-state-city";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import "react-country-state-city/dist/react-country-state-city.css";
import UserForm from "./UserForm";
import { fetchUser } from "slices/UserManagement/user/thunk";
import { fetchUserTypeDropdown } from "slices/UserManagement/UserType/thunk";
import LoadingSpinner from "components/LoadingSpinner";
import { useScrollToFormikError } from "hooks/useScrollToFormikError";
import { clearTableState } from "helpers/ClearTableState/ClearTableState";
import { TableKeys } from "Constants/TableKeys/TableKeys";
import { fetchAddressFromPincode } from "helpers/geonamesHelper";
interface BasicDetailsProps {
  setActiveTab: (tabName: string) => void;
}
const BasicDetails: React.FC<BasicDetailsProps> = ({ setActiveTab }) => {
  const location = useLocation();
  // const { user_data } = location.state || {};
  // const user_id = user_data?.user_id || "";
  const local_data = JSON.parse(localStorage.getItem("authUser") || "{}") || {};
  const [countries, setCountries] = useState<any>([]);
  const [states, setStates] = useState<any>([]);
  const [cities, setCities] = useState<any>([]);
  const { id } = useParams();

  const payload = {
    organization: "",
    department: "",
    team: "",
    first_name: "",
    last_name: "",
    username: "",
    designation: "",
    user_type: "",
    user_type_id: "",
    email: "",
    password: "",
    password2: "",
    mobile_number: "",
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
  };
  const [formData, setFormData] = useState<{ [key: string]: string }>(payload);

  const commonInputStyle = {
    fontSize: "0.8rem",
    minHeight: 38,
    padding: "0.375rem 0.75rem",
  };
  const commonLabelStyle = {
    fontSize: "0.8rem",
    marginBottom: 6,
    marginTop: 12,
  };
  const containerStyle = {
    marginTop: "2rem",
    marginLeft: 0,
    marginRight: 0,
    padding: "2rem 1rem",
    //maxWidth: 1200,
    width: "100%",
    borderRadius: "0.75rem",
  };
  const cardStyle = { padding: "2rem 1rem", borderRadius: "0.75rem" };

  const dropdownStyle = {
    border: "none",
    outline: "none",
    borderRadius: "4px",
    minHeight: "30px",
    fontSize: "0.95rem",
    background: "#fff",
    boxShadow: "none",
    padding: "0 8px",
    width: "100%",
  };

  const [errors, setErrors] = useState<Record<string, string>>({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [departmentOptions, setDepartmentOptions] = useState<any[]>([]);
  const [teamOptions, setTeamOptions] = useState<any[]>([]);
  const [nextPage, setNextPage] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [orgOptions, setOrgOptions] = useState<any[]>([]);
  const [selectedCountryId, setSelectedCountryId] = useState<any>("");
  const [selectedStateId, setSelectedStateId] = useState<any>("");
  const [isLoadingStates, setIsLoadingStates] = useState(false);
  const [isLoadingCities, setIsLoadingCities] = useState(false);

  const [isPageLoading, setIsPageLoading] = useState(false); // For page/data loading
  const [isSubmitting, setIsSubmitting] = useState(false); // For form submission
  const [submitCount, setSubmitCount] = useState(0);
  const [userTypeOptions, setUserTypeOptions] = useState<any[]>([]);

  useScrollToFormikError(errors, submitCount, isSubmitting);

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const { organizations, departments, teams } = useSelector(
    (state: any) => state.users.userFormDropDowns,
  );

  // Hardcoded user types array
  // const userTypeOptions = ["Admin", "Staff", "Technician"];

  useEffect(() => {
    const fetchUserType = async () => {
      try {
        const res = await dispatch(fetchUserTypeDropdown()).unwrap();
        setUserTypeOptions(res || []);
      } catch (error: any) {
        toast.error(error?.error || error?.message || "Something went wrong");
      }
    };
    fetchUserType();
  }, []);

  // useEffect(() => {
  //   dispatch(fetchALLUserFormDropdowns());
  // }, [dispatch]);

  // Fetch organizations
  useEffect(() => {
    // if (!organizations || organizations.length === 0) {
    Axios.get(API_ENDPOINT.USER_MANAGEMENT.ORGANIZATION.DROPDOWN)
      .then((res: any) => {
        if (res?.data?.data) {
          // Organizations are already in Redux, but we can ensure they're loaded

          setOrgOptions(res.data.data || res?.data || []);
        }
      })
      .catch((error: any) => {
        console.error("Error fetching organizations:", error);
      });
    // }
  }, []);
  useEffect(() => {
    const countryList = Country.getAllCountries();
    setCountries(countryList);
  }, []);

  useEffect(() => {
    if (formData.country) {
      const selectedCountry = countries.find(
        (c: any) => c.name?.toLowerCase() === formData.country?.toLowerCase(),
      );
      if (selectedCountry) {
        const newStates = State.getStatesOfCountry(selectedCountry.isoCode);
        setStates(newStates);
      }
    }
  }, [formData.country, countries]);

  useEffect(() => {
    if (formData.country && formData.state) {
      const selectedCountry = countries.find(
        (c: any) => c.name?.toLowerCase() === formData.country?.toLowerCase(),
      );
      const selectedState = states.find(
        (s: any) => s.name?.toLowerCase() === formData.state?.toLowerCase(),
      );
      if (selectedCountry && selectedState) {
        const newCities = City.getCitiesOfState(
          selectedCountry.isoCode,
          selectedState.isoCode,
        );
        setCities(newCities);
      }
    }
  }, [formData.state, states, formData.country, countries]);

  useEffect(() => {
    if (formData?.organization !== "") {
      Axios.get(
        API_ENDPOINT.USER_MANAGEMENT.DEPARTMENT.BY_ORG(formData.organization),
      )
        .then((res: any) => {
          if (res?.data?.status === 200 || res?.data?.status === 201) {
            setDepartmentOptions(res?.data?.data || []);
          } else {
            setDepartmentOptions([]);
          }
        })
        .catch((error: any) => {
          console.error("Error fetching departments:", error);
          setDepartmentOptions([]);
        });
    } else {
      setDepartmentOptions([]);
      setFormData((prev) => ({ ...prev, department: "", team: "" }));
    }
  }, [formData?.organization]);

  useEffect(() => {
    if (formData?.department !== "") {
      Axios.get(
        API_ENDPOINT.USER_MANAGEMENT.TEAM.BY_DEPARTMENT(formData.department),
      )
        .then((res: any) => {
          if (res?.data) {
            setTeamOptions(res?.data?.data || []);
          } else {
            setTeamOptions([]);
          }
        })
        .catch((error: any) => {
          console.error("Error fetching teams:", error);
          setTeamOptions([]);
        });
    } else {
      setTeamOptions([]);
      setFormData((prev) => ({ ...prev, team: "" }));
    }
  }, [formData?.department]);

  const validate = () => {
    const newErrors: Record<string, string> = {};

    // Helper function to check if a value is empty
    const isEmpty = (value: any) => {
      return value === null || value === undefined || value === "";
    };

    if (isEmpty(formData.organization))
      newErrors.organization = "Organisation is required";
    if (isEmpty(formData.department))
      newErrors.department = "Department is required";
    if (isEmpty(formData.team)) newErrors.team = "Team is required";
    if (isEmpty(formData.first_name?.trim()))
      newErrors.first_name = "First name is required";
    if (isEmpty(formData.last_name?.trim()))
      newErrors.last_name = "Last name is required";
    if (isEmpty(formData.username?.trim()))
      newErrors.username = "Username is required";
    if (isEmpty(formData.designation?.trim()))
      newErrors.designation = "Designation is required";
    if (isEmpty(formData.user_type))
      newErrors.user_type = "User type is required";
    if (isEmpty(formData.email?.trim())) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email.trim())) {
      newErrors.email = "Email is invalid";
    }
    // Password validation is required only for new user creation (not for updates)
    if (!id || id === undefined) {
      if (
        formData.password === "" ||
        formData.password === null ||
        formData.password === undefined ||
        formData.password.trim() === ""
      ) {
        newErrors.password = "Password is required";
      } else if (formData.password.length < 8) {
        newErrors.password = "Password must be at least 8 characters";
      }

      if (
        formData.password2 === "" ||
        formData.password2 === null ||
        formData.password2 === undefined ||
        formData.password2.trim() === ""
      ) {
        newErrors.password2 = "Confirm password is required";
      } else if (
        formData.password !== "" &&
        formData.password2 !== "" &&
        formData.password !== formData.password2
      ) {
        newErrors.password2 = "Passwords do not match";
      }
    }

    if (isEmpty(formData.mobile_number?.trim())) {
      newErrors.mobile_number = "Mobile number is required";
    } else if (formData.mobile_number?.trim().length < 10) {
      newErrors.mobile_number = "Mobile No. must be 10 digits";
    }

    if (
      formData.pincode?.toString().trim() &&
      !/^\d{6}$/.test(formData.pincode.toString().trim())
    ) {
      newErrors.pincode = "Pincode must be 6 digits";
    }
    return newErrors;
  };

  const handlePincodeBlur = async () => {
    const pin = formData.pincode?.toString().trim();
    if (!pin) return;

    const selectedCountry = countries.find(
      (c: any) => c.name?.toLowerCase() === formData.country?.toLowerCase()
    );
    const countryCode = selectedCountry?.isoCode;

    try {
      const data = await fetchAddressFromPincode(pin, countryCode);
      if (data) {
        const resolvedCountry = countries.find(
          (c: any) => c.isoCode === data.countryCode
        ) || Country.getAllCountries().find(
          (c: any) => c.isoCode === data.countryCode
        );

        if (resolvedCountry) {
          const countryStates = State.getStatesOfCountry(resolvedCountry.isoCode);
          setStates(countryStates);

          const resolvedState = countryStates.find(
            (s: any) =>
              s.name?.toLowerCase() === data.adminName1?.toLowerCase() ||
              s.isoCode?.toLowerCase() === data.adminCode1?.toLowerCase()
          );

          let stateCities: any[] = [];
          if (resolvedState) {
            stateCities = City.getCitiesOfState(
              resolvedCountry.isoCode,
              resolvedState.isoCode
            );
            setCities(stateCities);
          }

          setFormData((prev) => ({
            ...prev,
            country: resolvedCountry.name,
            state: resolvedState ? resolvedState.name : data.adminName1 || "",
            city: data.placeName || "",
          }));
        }
      }
    } catch (err) {
      console.error("Failed to fetch address details for pincode", err);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitCount((prev) => prev + 1);
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      // Prioritize showing specific error messages
      // Check for password-related errors first
      // if (validationErrors.password2 === "Passwords do not match") {
      //   toast.error("Passwords do not match");
      // } else if (validationErrors.password2 === "Confirm password is required") {
      //   toast.error("Confirm password is required");
      // } else if (
      //   validationErrors.password === "Password must be at least 8 characters"
      // ) {
      //   toast.error("Password must be at least 8 characters");
      // } else if (validationErrors.password === "Password is required") {
      //   toast.error("Password is required");
      // } else {
      //   // Show the first error message, or fallback to field names
      //   const firstErrorKey = Object.keys(validationErrors)[0];
      //   const firstErrorMessage = validationErrors[firstErrorKey];

      //   if (firstErrorMessage) {
      //     toast.error(firstErrorMessage);
      //   } else {
      //     const errorFields = Object.keys(validationErrors).join(", ");
      //     toast.error(`Please fill all required fields: ${errorFields}`);
      //   }
      // }
      // console.log("validationErrors: ", validationErrors);
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      localStorage.removeItem("permission_user");
      let response;

      const cleanPayload = {
        organization: formData.organization || "",
        department: formData.department || "",
        team: formData.team || "",
        first_name: formData.first_name?.toString().trim() || "",
        last_name: formData.last_name?.toString().trim() || "",
        username: formData.username?.toString().trim() || "",
        designation: formData.designation?.toString().trim() || "",
        user_type: formData.user_type || "",
        user_type_id: formData.user_type_id || "",
        email: formData.email?.toString().trim() || "",
        mobile_number: formData.mobile_number?.toString().trim() || "",
        address: formData.address?.toString().trim() || "",
        city: formData.city?.toString().trim() || "",
        state: formData.state?.toString().trim() || "",
        country: formData.country?.toString().trim() || "",
        pincode: formData.pincode?.toString().trim() || "",
        password: formData.password || "",
        password2: formData.password2 || "",
      };

      if (id) {
        response = await Axios.put(
          API_ENDPOINT.USER_MANAGEMENT.USER.UPDATE(id),
          { ...cleanPayload, id },
        );
      } else {
        response = await Axios.post(
          API_ENDPOINT.USER_MANAGEMENT.USER.CREATE,
          cleanPayload,
        );
        clearTableState(TableKeys?.USER_MANAGEMENT?.USER);
      }

      if (response.status === 200 || response.status === 201) {
        const userId = id || response?.data?.data?.user_id;
        toast.success(`User ${id ? "updated" : "created"} successfully`);
        setTimeout(() => {
          // Store user_id in localStorage for PermissionTab to access
          localStorage.setItem("permission_user", JSON.stringify(userId));
          setNextPage(true);
          setActiveTab("permissions");
        }, 1000);
      } else {
        toast.error(`Failed to ${id ? "update" : "create"} user`);
      }
    } catch (error: any) {
      const errorData = error?.response?.data;
      // console.log("Error Data =>",errorData)
      if (
        errorData.message.includes("A user with this username already exists")
      ) {
        toast.error(errorData.message);
        return;
      }
      // Case 1: Use message if already clean
      if (errorData?.message && typeof errorData.message === "string") {
        const messageParts = errorData.message.split(": ");
        if (messageParts.length > 1) {
          toast.error(messageParts[1]); // Just the message
        } else {
          toast.error(errorData.message);
        }
      }

      // Case 2: Extract from stringified error dict with ErrorDetail
      else if (typeof errorData?.error === "string") {
        try {
          const cleanedError = errorData.error
            .replace(/'/g, '"')
            .replace(/ErrorDetail\(string=/g, '"')
            .replace(/, code=[^)]+\)/g, '"');

          const parsedError = JSON.parse(cleanedError);
          const firstKey = Object.keys(parsedError)[0];
          const firstMessage = parsedError[firstKey]?.[0] || "Validation error";
          toast.error(firstMessage);
        } catch (parseErr) {
          toast.error("An unknown error occurred.");
        }
      }

      // Fallback
      else {
        toast.error("Failed to save user");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClickShowPassword = () => setShowPassword((prev) => !prev);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((prev) => !prev);
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };

  // After fetching user data, set countryId and formData
  useEffect(() => {
    if (id) {
      setIsPageLoading(true);

      Axios.get(API_ENDPOINT.USER_MANAGEMENT.USER.DETAIL(id))
        .then((res: any) => {
          const response = res?.data?.data || res?.data || [];
          const allCountries = Country.getAllCountries();
          const selectedCountry = allCountries.find(
            (c) => c.name?.toLowerCase() === response.country?.toLowerCase(),
          );

          const countryIsoCode = selectedCountry?.isoCode || "";

          const statesOfCountry = countryIsoCode
            ? State.getStatesOfCountry(countryIsoCode)
            : [];
          const selectedState = statesOfCountry.find(
            (s) => s.name?.toLowerCase() === response.state?.toLowerCase(),
          );

          const stateIsoCode = selectedState?.isoCode || "";

          const citiesOfState =
            countryIsoCode && stateIsoCode
              ? City.getCitiesOfState(countryIsoCode, stateIsoCode)
              : [];

          setCountries(allCountries);
          setStates(statesOfCountry);
          setCities(citiesOfState);

          const orgId = response?.organization?.organization_id || "";
          const deptId = response?.department?.department_id || "";
          const teamId = response?.team?.team_id || "";

          setFormData({
            organization: orgId,
            department: deptId,
            team: teamId,
            first_name: response?.first_name || "",
            last_name: response?.last_name || "",
            username: response?.username || "",
            designation: response?.designation || "",
            user_type_id: response?.user_type_id || "",
            user_type: response?.user_type || "",
            email: response?.email || "",
            password: "",
            password2: "",
            mobile_number: response?.mobile_number || "",
            address: response?.address || "",
            city: response?.city || "",
            state: response?.state || "",
            country: response?.country || "",
            pincode: response?.pincode || "",
            country_id: response.country_id || "",
            state_id: response.state_id || "",
          });

          // Fetch departments based on organization
          if (orgId) {
            Axios.get(API_ENDPOINT.USER_MANAGEMENT.DEPARTMENT.BY_ORG(orgId))
              .then((deptRes: any) => {
                if (
                  deptRes?.data?.status === 200 ||
                  deptRes?.data?.status === 201
                ) {
                  setDepartmentOptions(deptRes?.data?.data || []);

                  // After departments are loaded, fetch teams if department is selected
                  if (deptId) {
                    Axios.get(
                      API_ENDPOINT.USER_MANAGEMENT.TEAM.BY_DEPARTMENT(deptId),
                    )
                      .then((teamRes: any) => {
                        if (teamRes?.data) {
                          setTeamOptions(teamRes?.data?.data || []);
                        }
                      })
                      .catch((error: any) => {
                        console.error("Error fetching teams:", error);
                      });
                  }
                }
              })
              .catch((error: any) => {
                console.error("Error fetching departments:", error);
              });
          }
        })
        .catch((error) => {
          console.error("Error fetching user data:", error);
          toast.error("Failed to fetch user details");
        })
        .finally(() => {
          setIsPageLoading(false);
        });
    }
  }, [id]);

  return (
    <div>
      {nextPage ? (
        <UserForm page={"permissions"} />
      ) : (
        <div
          className="add-organization-container bg-white"
          style={containerStyle}
        >
          {/* Header Section */}
          <div className="">
            <div className="d-flex justify-content-between align-items-start align-items-md-center flex-wrap gap-2">
              {/* Left: Back arrow + title */}
              <div className="d-flex align-items-center">
                <span
                  style={{
                    cursor: "pointer",
                    fontSize: "1.5rem",
                    lineHeight: 1,
                  }}
                  onClick={() => navigate(-1)}
                >
                  <i className="bi bi-arrow-left"></i>
                </span>
                <h5 className="mb-0 fw-bold ms-2">
                  {id ? "Edit" : "Create"} User
                </h5>
              </div>
              {/* Right: Breadcrumb */}
              <div className="text-muted" style={{ fontSize: "0.85rem" }}>
                <Link
                  to="/user-list"
                  className="text-decoration-none text-muted"
                >
                  Users
                </Link>{" "}
                &gt;{" "}
                <span className="text-muted">
                  {id ? "Edit User" : "Add User"}
                </span>
              </div>
            </div>
          </div>

          <hr />

          {isPageLoading ? (
            <LoadingSpinner />
          ) : (
            <Card className="shadow-sm" style={cardStyle}>
              <Form noValidate onSubmit={handleSubmit}>
                <Row className="mb-4">
                  <Col md={4} xs={12} className="mb-3 mb-md-0">
                    <Form.Label
                      className="fw-semibold"
                      style={commonLabelStyle}
                    >
                      Organisation <span className="text-danger">*</span>
                    </Form.Label>
                    <Autocomplete
                      disablePortal
                      options={orgOptions}
                      getOptionLabel={(option: any) =>
                        option?.organization_name || ""
                      }
                      value={
                        orgOptions?.find(
                          (org: any) =>
                            org?.organization_id === formData?.organization,
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFormData((prev) => ({
                          ...prev,
                          organization: value?.organization_id || "",
                          department: "",
                          team: "",
                        }));
                        setErrors((prev) => ({
                          ...prev,
                          organization: "",
                          department: "",
                          team: "",
                        }));
                      }}
                      ListboxProps={autocompleteDropdownStyles.ListboxProps}
                      renderInput={(params) => (
                        <BootstrapTextField
                          {...params}
                          placeholder="Select Organisation"
                          id="organization"
                          name="organization"
                          error={!!errors.organization}
                          helperText={errors.organization}
                          fullWidth
                          size="small"
                          sx={{
                            // background: "#FFF",
                            ...autocompleteDropdownStyles.inputSx,
                          }}
                        />
                      )}
                    />
                  </Col>

                  <Col md={4} xs={12} className="mb-3 mb-md-0">
                    <Form.Label
                      className="fw-semibold"
                      style={commonLabelStyle}
                    >
                      Department <span className="text-danger">*</span>
                    </Form.Label>
                    <Autocomplete
                      disablePortal
                      options={departmentOptions}
                      getOptionLabel={(option: any) =>
                        option.department_name || ""
                      }
                      value={
                        departmentOptions?.find(
                          (dept: any) =>
                            dept?.department_id === formData?.department,
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFormData((prev) => ({
                          ...prev,
                          department: value?.department_id || "",
                          team: "",
                        }));
                        setErrors((prev) => ({
                          ...prev,
                          department: "",
                          team: "",
                        }));
                      }}
                      ListboxProps={autocompleteDropdownStyles.ListboxProps}
                      renderInput={(params) => (
                        <BootstrapTextField
                          {...params}
                          placeholder="Select Department"
                          id="department"
                          name="department"
                          error={!!errors.department}
                          helperText={errors.department}
                          fullWidth
                          size="small"
                          sx={{
                            // background: "#FFF",
                            ...autocompleteDropdownStyles.inputSx,
                          }}
                        />
                      )}
                      disabled={!formData?.organization}
                    />
                  </Col>
                  <Col md={4} xs={12}>
                    <Form.Label
                      className="fw-semibold"
                      style={commonLabelStyle}
                    >
                      Team <span className="text-danger">*</span>
                    </Form.Label>
                    <Autocomplete
                      disablePortal
                      options={teamOptions}
                      getOptionLabel={(option: any) => option.team_name || ""}
                      value={
                        teamOptions?.find(
                          (team: any) => team?.team_id === formData?.team,
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFormData((prev) => ({
                          ...prev,
                          team: value?.team_id || "",
                        }));
                        setErrors((prev) => ({ ...prev, team: "" }));
                      }}
                      ListboxProps={autocompleteDropdownStyles.ListboxProps}
                      renderInput={(params) => (
                        <BootstrapTextField
                          {...params}
                          placeholder="Select Team"
                          id="team"
                          name="team"
                          error={!!errors.team}
                          helperText={errors.team}
                          fullWidth
                          size="small"
                          sx={{
                            // background: "#FFF",
                            ...autocompleteDropdownStyles.inputSx,
                          }}
                        />
                      )}
                      disabled={!formData?.department}
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={4} xs={12} className="mb-3 mb-md-0">
                    <Form.Label
                      className="fw-semibold"
                      style={commonLabelStyle}
                    >
                      First Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      id="first_name"
                      name="first_name"
                      placeholder="Enter First Name"
                      value={formData.first_name}
                      onChange={handleChange}
                      isInvalid={!!errors.first_name}
                      size="sm"
                      style={commonInputStyle}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.first_name}
                    </Form.Control.Feedback>
                  </Col>
                  <Col md={4} xs={12} className="mb-3 mb-md-0">
                    <Form.Label
                      className="fw-semibold"
                      style={commonLabelStyle}
                    >
                      Last Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      id="last_name"
                      name="last_name"
                      placeholder="Enter Last Name"
                      value={formData.last_name}
                      onChange={handleChange}
                      isInvalid={!!errors.last_name}
                      size="sm"
                      style={commonInputStyle}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.last_name}
                    </Form.Control.Feedback>
                  </Col>
                  <Col md={4} xs={12} className="mb-3 mb-md-0">
                    <Form.Label
                      className="fw-semibold"
                      style={commonLabelStyle}
                    >
                      User Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      id="username"
                      name="username"
                      placeholder="Enter User Name"
                      value={formData.username}
                      onChange={handleChange}
                      isInvalid={!!errors.username}
                      size="sm"
                      style={commonInputStyle}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.username}
                    </Form.Control.Feedback>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={4} xs={12} className="mb-3 mb-md-0">
                    <Form.Label
                      className="fw-semibold"
                      style={commonLabelStyle}
                    >
                      Designation <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      id="designation"
                      name="designation"
                      placeholder="Enter Designation"
                      value={formData.designation}
                      onChange={handleChange}
                      isInvalid={!!errors.designation}
                      size="sm"
                      style={commonInputStyle}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.designation}
                    </Form.Control.Feedback>
                  </Col>
                  <Col md={4} xs={12} className="mb-3 mb-md-0">
                    <Form.Label
                      className="fw-semibold"
                      style={commonLabelStyle}
                    >
                      User Type <span className="text-danger">*</span>
                    </Form.Label>
                    <Autocomplete
                      disablePortal
                      options={userTypeOptions}
                      getOptionLabel={(option: any) => option.user_type || ""}
                      value={
                        userTypeOptions.find(
                          (opt: any) =>
                            opt.user_type_id === formData.user_type_id,
                        ) || null
                      }
                      onChange={(_, selected) => {
                        setFormData((prev) => ({
                          ...prev,
                          // user_type_id: selected?.user_type_id || "",
                          user_type: selected?.user_type || "",
                          user_type_id: selected?.user_type_id || "",
                        }));
                        setErrors((prev) => ({ ...prev, user_type: "" }));
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.user_type_id === value.user_type_id
                      }
                      ListboxProps={autocompleteDropdownStyles.ListboxProps}
                      renderInput={(params) => (
                        <BootstrapTextField
                          {...params}
                          placeholder="Select User Type"
                          id="user_type"
                          name="user_type"
                          error={!!errors.user_type}
                          helperText={errors.user_type}
                          fullWidth
                          size="small"
                          sx={autocompleteDropdownStyles.inputSx}
                        />
                      )}
                    />
                  </Col>
                  <Col md={4} xs={12} className="mb-3 mb-md-0">
                    <Form.Label
                      className="fw-semibold"
                      style={commonLabelStyle}
                    >
                      Email <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Enter Email"
                      value={formData.email}
                      onChange={handleChange}
                      isInvalid={!!errors.email}
                      size="sm"
                      style={commonInputStyle}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </Col>
                </Row>
                <Row className="mb-4">
                  {!id && (
                    <Col md={4} xs={12} className="mb-3 mb-md-0">
                      <Form.Label
                        className="fw-semibold"
                        style={commonLabelStyle}
                      >
                        Password <span className="text-danger">*</span>
                      </Form.Label>
                      <div style={{ position: "relative" }}>
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          id="password"
                          name="password"
                          placeholder="Enter Password"
                          value={formData.password}
                          onChange={handleChange}
                          isInvalid={!!errors.password}
                          size="sm"
                          autoComplete="new-password"
                          style={{ ...commonInputStyle, paddingRight: 40 }}
                        />
                        <span
                          style={{
                            position: "absolute",
                            right: 10,
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            zIndex: 2,
                            color: "#6c757d",
                          }}
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? (
                            <Visibility fontSize="small" />
                          ) : (
                            <VisibilityOff fontSize="small" />
                          )}
                        </span>
                      </div>
                      {errors.password && (
                        <div
                          className="invalid-feedback d-block"
                          style={{ minHeight: "1.25rem", marginTop: "0.25rem" }}
                        >
                          {errors.password}
                        </div>
                      )}
                    </Col>
                  )}

                  {!id && (
                    <Col md={4} xs={12} className="mb-3 mb-md-0">
                      <Form.Label
                        className="fw-semibold"
                        style={commonLabelStyle}
                      >
                        Confirm Password <span className="text-danger">*</span>
                      </Form.Label>
                      <div style={{ position: "relative" }}>
                        <Form.Control
                          type={showConfirmPassword ? "text" : "password"}
                          id="password2"
                          name="password2"
                          placeholder="Enter Confirm Password"
                          value={formData.password2}
                          onChange={handleChange}
                          isInvalid={!!errors.password2}
                          size="sm"
                          autoComplete="new-password"
                          style={{ ...commonInputStyle, paddingRight: 40 }}
                        />
                        <span
                          style={{
                            position: "absolute",
                            right: 10,
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            zIndex: 2,
                            color: "#6c757d",
                          }}
                          onClick={handleClickShowConfirmPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showConfirmPassword ? (
                            <Visibility fontSize="small" />
                          ) : (
                            <VisibilityOff fontSize="small" />
                          )}
                        </span>
                      </div>
                      {errors.password2 && (
                        <div
                          className="invalid-feedback d-block"
                          style={{ minHeight: "1.25rem", marginTop: "0.25rem" }}
                        >
                          {errors.password2}
                        </div>
                      )}
                    </Col>
                  )}

                  <Col md={4} xs={12}>
                    <Form.Label
                      className="fw-semibold"
                      style={commonLabelStyle}
                    >
                      Mobile Number <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      id="mobile_number"
                      name="mobile_number"
                      placeholder="Enter Mobile Number"
                      value={formData.mobile_number}
                      onChange={handleChange}
                      isInvalid={!!errors.mobile_number}
                      size="sm"
                      maxLength={10}
                      style={commonInputStyle}
                    />
                    <Form.Control.Feedback
                      type="invalid"
                      style={{ minHeight: "1.25rem", marginTop: "0.25rem" }}
                    >
                      {errors.mobile_number}
                    </Form.Control.Feedback>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col xs={12}>
                    <Form.Label
                      className="fw-semibold"
                      style={commonLabelStyle}
                    >
                      Address
                      {/* <span className="text-danger">*</span> */}
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      id="address"
                      name="address"
                      placeholder="Enter Address"
                      value={formData.address}
                      onChange={handleChange}
                      isInvalid={!!errors.address}
                      size="sm"
                      style={commonInputStyle}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.address}
                    </Form.Control.Feedback>
                  </Col>
                </Row>
                <Row className="mb-4">
                <Col md={4} xs={12} className="mb-4 mb-md-0">
                    <Form.Label
                      className="fw-semibold"
                      style={commonLabelStyle}
                    >
                      Pincode
                      {/* <span className="text-danger">*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      id="pincode"
                      name="pincode"
                      placeholder="Enter Pincode"
                      value={formData.pincode}
                      onChange={handleChange}
                      onBlur={handlePincodeBlur}
                      isInvalid={!!errors.pincode}
                      size="sm"
                      style={commonInputStyle}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.pincode}
                    </Form.Control.Feedback>
                  </Col>
                  <Col md={4} xs={12} className="mb-3">
                    <Form.Label
                      className="fw-semibold"
                      style={commonLabelStyle}
                    >
                      Country
                      {/* <span className="text-danger">*</span> */}
                    </Form.Label>
                    <Autocomplete
                      disablePortal
                      options={countries}
                      getOptionLabel={(option) => option.name}
                      value={
                        countries.find(
                          (c: any) =>
                            c.name?.toLowerCase() ===
                            formData.country?.toLowerCase(),
                        ) || null
                      }
                      onChange={(e, selectedCountry) => {
                        setFormData((prev) => ({
                          ...prev,
                          country: selectedCountry?.name || "",
                          state: "",
                          city: "",
                        }));
                        
                        if (selectedCountry) {
                          setIsLoadingStates(true);
                          const newStates = State.getStatesOfCountry(
                            selectedCountry.isoCode,
                          );
                          setStates(newStates);
                          setCities([]);
                          setIsLoadingStates(false);
                        } else {
                          setStates([]);
                          setCities([]);
                        }
                      }}
                      ListboxProps={autocompleteDropdownStyles.ListboxProps}
                      renderInput={(params) => (
                        <BootstrapTextField
                          {...params}
                          placeholder="Select Country"
                          id="country"
                          name="country"
                          error={!!errors.country}
                          helperText={errors.country}
                          fullWidth
                          size="small"
                          sx={{
                            ...autocompleteDropdownStyles.inputSx,
                          }}
                        />
                      )}
                    />
                  </Col>

                  <Col md={4} xs={12} className="mb-3">
                    <Form.Label
                      className="fw-semibold"
                      style={commonLabelStyle}
                    >
                      {states.length > 0 ? "State" : "State / Region"}{" "}
                    </Form.Label>
                    {states.length > 0 ? (
                      <Autocomplete
                        disablePortal
                        options={states}
                        getOptionLabel={(option) => option.name}
                        loading={isLoadingStates}
                        value={
                          states.find(
                            (s: any) =>
                              s.name?.toLowerCase() ===
                              formData.state?.toLowerCase(),
                          ) || null
                        }
                        onChange={(e, selectedState) => {
                          const selectedCountry = countries.find(
                            (c: any) =>
                              c.name?.toLowerCase() ===
                              formData.country?.toLowerCase(),
                          );

                          setFormData((prev) => ({
                            ...prev,
                            state: selectedState?.name || "",
                            city: "",
                          }));
                          
                          if (selectedCountry && selectedState) {
                            setIsLoadingCities(true);
                            const newCities = City.getCitiesOfState(
                              selectedCountry.isoCode,
                              selectedState.isoCode,
                            );
                            setCities(newCities);
                            setIsLoadingCities(false);
                          } else {
                            setCities([]);
                          }
                        }}
                        ListboxProps={autocompleteDropdownStyles.ListboxProps}
                        renderInput={(params) => (
                          <BootstrapTextField
                            {...params}
                            placeholder="Select State"
                            id="state"
                            name="state"
                            error={!!errors.state}
                            helperText={errors.state}
                            fullWidth
                            size="small"
                            sx={{
                              ...autocompleteDropdownStyles.inputSx,
                            }}
                          />
                        )}
                        disabled={!formData.country}
                      />
                    ) : (
                      <Form.Control
                        type="text"
                        id="state"
                        name="state"
                        placeholder="Enter State / Region"
                        value={formData.state}
                        onChange={handleChange}
                        style={commonInputStyle}
                        disabled={!formData.country}
                      />
                    )}
                  </Col>

                  <Col md={4} xs={12} className="mb-3">
                    {(() => {
                      const hasStates = states.length > 0;
                      const hasCities = cities.length > 0;
                      const showCityDropdown =
                        hasStates && (!formData.state || hasCities);

                      return (
                        <>
                          <Form.Label
                            className="fw-semibold"
                            style={commonLabelStyle}
                          >
                            City{" "}
                          </Form.Label>
                          {showCityDropdown ? (
                            <Autocomplete
                              disablePortal
                              options={cities}
                              getOptionLabel={(option) => option.name}
                              loading={isLoadingCities}
                              value={
                                cities.find(
                                  (c: any) =>
                                    c.name?.toLowerCase() ===
                                    formData.city?.toLowerCase(),
                                ) || null
                              }
                              onChange={(e, selectedCity) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  city: selectedCity?.name || "",
                                }));
                                // setErrors((prev) => ({ ...prev, city: "" }));
                              }}
                              ListboxProps={
                                autocompleteDropdownStyles.ListboxProps
                              }
                              renderInput={(params) => (
                                <BootstrapTextField
                                  {...params}
                                  placeholder="Select City"
                                  id="city"
                                  name="city"
                                  error={!!errors.city}
                                  helperText={errors.city}
                                  fullWidth
                                  size="small"
                                  sx={{
                                    ...autocompleteDropdownStyles.inputSx,
                                  }}
                                />
                              )}
                              disabled={!formData.state}
                            />
                          ) : (
                            <Form.Control
                              type="text"
                              id="city"
                              name="city"
                              placeholder="Enter City"
                              value={formData.city}
                              onChange={handleChange}
                              style={commonInputStyle}
                              disabled={!formData.country}
                            />
                          )}
                        </>
                      );
                    })()}
                  </Col>
                  
                </Row>
                <div className="d-flex flex-column flex-md-row justify-content-center gap-3 mt-3">
                  <CancelButton onClick={() => navigate("/user-list")} />
                  <PrimarySubmitButton
                    label={id ? "Update" : "Next"}
                    type="submit"
                    isLoading={isSubmitting}
                    loadingLabel={id ? "Updating..." : "Creating..."}
                  />
                </div>
              </Form>
            </Card>
          )}
        </div>
      )}
    </div>
  );
};

export default BasicDetails;
